import api from './api'

export const csvImportApi = {
  downloadTemplate() {
    const token = localStorage.getItem('access_token')
    const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000/api'

    const link = document.createElement('a')
    link.href = `${baseUrl}/csv-import/template`
    link.setAttribute('download', 'plantilla_importacion_usuarios.csv')
    link.style.display = 'none'

    const headers = new Headers()
    if (token) {
      headers.append('Authorization', `Bearer ${token}`)
    }

    fetch(link.href, { headers })
      .then((response) => {
        if (!response.ok) throw new Error('Error al descargar plantilla')
        return response.blob()
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'plantilla_importacion_usuarios.csv'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      })
      .catch((error) => {
        console.error('Error downloading template:', error)
        throw error
      })
  },

  async preview(file) {
    const formData = new FormData()
    formData.append('file', file)

    const response = await api.post('/csv-import/preview', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    })

    return response
  },

  async import(file) {
    const formData = new FormData()
    formData.append('file', file)

    const response = await api.post('/csv-import/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    })

    return response
  },

  async getHistory() {
    const response = await api.get('/csv-import/history')
    return response
  },

  async getImport(id) {
    const response = await api.get(`/csv-import/${id}`)
    return response
  },

  async getErrors(id) {
    const response = await api.get(`/csv-import/${id}/errors`)
    return response
  },
}
